/* eslint-disable no-nested-ternary */
import BarChart from './bar-chart';
import '../../simulation-summary.scss';
import './index.scss';
import { dummyChartData } from '../../../../../../testData/simulation-summary-data';
import { ColorData } from '../../utils/constants';
import { Grid, Skeleton } from '@mui/material';

export default function SkeletonForSummary() {
  const axisKeys = [
    {
      key: 'current',
      alias: 'Current',
      color: ColorData.greyColor
    },
    {
      key: 'new',
      alias: 'New',
      color: ColorData.greyColor
    }
  ];

  const dummySkeleton = () => (
    <>
      <div
        style={{
          marginRight: '10px',
          marginTop: '-15px',
          marginBottom: '20px'
        }}
      >
        <Grid item xs={1}>
          <Skeleton variant='rectangular' sx={{ width: 100, height: 20 }} />
        </Grid>
        <BarChart
          barWidthValue={100}
          barData={dummyChartData}
          height={60}
          axisKeys={axisKeys}
        />
      </div>
      <div style={{ marginRight: '10px' }}>
        <div style={{ marginBottom: '20px' }}>
          <Skeleton variant='rectangular' sx={{ width: 100, height: 20 }} />
          <BarChart
            barWidthValue={100}
            barData={dummyChartData}
            height={60}
            axisKeys={axisKeys}
          />
        </div>
      </div>
    </>
  );
  // rendering charts component dynamically as per the summary data
  return <>{dummySkeleton()}</>;
}
